import React, { useEffect, useMemo, useState } from "react";
import api from "../../../api/axios";
import "./DesviosPage.css";

/* POPUPS */
import AtivarDesvio from "./popups/AtivarDesvio.jsx";
import InativarDesvio from "./popups/InativarDesvio.jsx";
import ExcluirDesvio from "./popups/ExcluirDesvio.jsx";
import CriarDesvio from "./popups/CriarDesvio.jsx";
import EditarDesvio from "./popups/EditarDesvio.jsx";
import CriarPrimaria from "./popups/CriarPrimaria.jsx";

/* helpers */
const UP = (v) => (typeof v === "string" ? v.toUpperCase() : v ?? "");

function IconEdit(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  );
}
function IconTrash(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    </svg>
  );
}

function ToggleSwitch({ on = false, onToggle, title }) {
  return (
    <button
      type="button"
      aria-pressed={on}
      className={`dvz-toggle ${on ? "on" : "off"}`}
      onClick={onToggle}
      title={title || (on ? "Inativar" : "Ativar")}
    >
      <span className="knob" />
    </button>
  );
}

export default function DesviosPage({ onBack }) {
  const [arvore, setArvore] = useState({});
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [filtroCausador, setFiltroCausador] = useState(null);

  const [popup, setPopup] = useState({ type: null, payload: null });
  const openPopup = (type, payload) => setPopup({ type, payload });
  const closePopup = () => setPopup({ type: null, payload: null });

  const [openCriar, setOpenCriar] = useState(false);
  const [editarRow, setEditarRow] = useState(null);

  const [openCriarPrimaria, setOpenCriarPrimaria] = useState(false);
  const [ctxPrimaria, setCtxPrimaria] = useState(null);

  useEffect(() => {
    document.body.classList.add("dvz-skin");
    return () => document.body.classList.remove("dvz-skin");
  }, []);

  async function carregar() {
    setLoading(true); setErr("");
    try {
      const r = await api.get("/desvios/arvore");
      setArvore(r.data?.data || {});
    } catch (e) {
      setErr(e?.response?.data?.error || e.message || "Erro ao listar");
      setArvore({});
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { carregar(); }, []);

  /* ===== métricas ===== */
  const stats = useMemo(() => {
    const causadores = Object.keys(arvore);
    const totalCausadores = causadores.length;

    let primarias = 0, primariasAtivas = 0, primariasInativas = 0;
    let secundarias = 0, secundariasAtivas = 0, secundariasInativas = 0;
    let causadoresAtivos = 0, causadoresInativos = 0;

    const porCausador = {};
    for (const c of causadores) {
      const prims = Object.keys(arvore[c] || {});
      primarias += prims.length;

      let hasAtivaNoCausador = false;
      for (const p of prims) {
        const arr = arvore[c][p] || [];
        secundarias += arr.length;

        const temAtivaNaPrimaria = arr.some(it => Number(it.ativo));
        if (temAtivaNaPrimaria) primariasAtivas++; else primariasInativas++;

        for (const it of arr) {
          if (Number(it.ativo)) { secundariasAtivas++; hasAtivaNoCausador = true; }
          else secundariasInativas++;
        }
      }

      porCausador[UP(c)] = Object.values(arvore[c] || {}).reduce((n, a) => n + a.length, 0);
      if (hasAtivaNoCausador) causadoresAtivos++; else causadoresInativos++;
    }

    const chips = Object.entries(porCausador)
      .sort((a,b)=> a[0].localeCompare(b[0],"pt-BR",{sensitivity:"base"}));

    return {
      totalCausadores, causadoresAtivos, causadoresInativos,
      primarias, primariasAtivas, primariasInativas,
      secundarias, secundariasAtivas, secundariasInativas,
      chips
    };
  }, [arvore]);

  /* ===== helpers ===== */
  function buildRows(mapPrimarias = {}) {
    const out = [];
    const prims = Object.keys(mapPrimarias);
    prims.forEach((prim, pi) => {
      const list = [...mapPrimarias[prim]];
      list.sort((a,b)=> String(a.causa_secundaria||"").localeCompare(String(b.causa_secundaria||""), "pt-BR", {sensitivity:"base"}));
      if (pi > 0) out.push({ _sep: true, _key: `sep-${prim}-${pi}` });
      list.forEach((row, idx) => {
        out.push({ ...row, _showPrimaria: idx === 0, _span: list.length, _primaria: prim });
      });
    });
    return out;
  }

  const isCausadorAtivo = (causador) => {
    const map = arvore[causador] || {};
    for (const arr of Object.values(map)) {
      if (arr.some(r => Number(r.ativo))) return true;
    }
    return false;
  };

  const microSetAtivo = (id, ativo) => {
    setArvore(prev => {
      const next = structuredClone(prev);
      for (const c of Object.keys(next)) {
        for (const p of Object.keys(next[c])) {
          const arr = next[c][p];
          const i = arr.findIndex(r => r.id === id);
          if (i >= 0) { arr[i].ativo = ativo ? 1 : 0; return next; }
        }
      }
      return next;
    });
  };
  const microRemove = (id) => {
    setArvore(prev => {
      const next = structuredClone(prev);
      for (const c of Object.keys(next)) {
        for (const p of Object.keys(next[c])) {
          const arr = next[c][p];
          const i = arr.findIndex(r => r.id === id);
          if (i >= 0) {
            arr.splice(i,1);
            if (arr.length === 0) delete next[c][p];
            if (Object.keys(next[c]||{}).length === 0) delete next[c];
            return next;
          }
        }
      }
      return next;
    });
  };

  async function confirmPopup() {
    const { type, payload } = popup || {};
    try {
      if (!type) return;

      if (type === "ativar-secundaria") {
        await api.patch(`/desvios/alterar-ativo/${payload.id}`, { ativo: 1 });
        microSetAtivo(payload.id, 1);
      }
      if (type === "inativar-secundaria") {
        await api.patch(`/desvios/alterar-ativo/${payload.id}`, { ativo: 0 });
        microSetAtivo(payload.id, 0);
      }
      if (type === "excluir-secundaria") {
        await api.delete(`/desvios/excluir/${payload.id}`);
        microRemove(payload.id);
      }

      if (type === "ativar-causador") {
        await api.patch(`/desvios/alterar-ativo-causador`, { causador: payload.causador, ativo: 1 });
        setArvore(prev => {
          const next = structuredClone(prev);
          const map = next[payload.causador] || {};
          Object.values(map).forEach(arr => arr.forEach(r => r.ativo = 1));
          return next;
        });
      }
      if (type === "inativar-causador") {
        await api.patch(`/desvios/alterar-ativo-causador`, { causador: payload.causador, ativo: 0 });
        setArvore(prev => {
          const next = structuredClone(prev);
          const map = next[payload.causador] || {};
          Object.values(map).forEach(arr => arr.forEach(r => r.ativo = 0));
          return next;
        });
      }
      if (type === "excluir-causador") {
        await api.delete(`/desvios/excluir-causador`, { params: { causador: payload.causador } });
        setArvore(prev => {
          const next = structuredClone(prev);
          delete next[payload.causador];
          return next;
        });
      }

      closePopup();
    } catch (e) {
      alert(e?.response?.data?.error || e.message || "Erro ao executar ação");
    }
  }

  function pedirToggleSec(row) {
    if (Number(row.ativo)) openPopup("inativar-secundaria", { id: row.id, rotulo: row.causa_secundaria });
    else openPopup("ativar-secundaria", { id: row.id, rotulo: row.causa_secundaria });
  }
  function pedirExcluirSec(row) {
    openPopup("excluir-secundaria", { id: row.id, rotulo: row.causa_secundaria });
  }
  function pedirToggleCausador(causador) {
    if (isCausadorAtivo(causador)) openPopup("inativar-causador", { causador });
    else openPopup("ativar-causador", { causador });
  }
  function pedirExcluirCausador(causador) {
    openPopup("excluir-causador", { causador });
  }

  function abrirPopupPrimaria(causador) {
    setCtxPrimaria({ causador });
    setOpenCriarPrimaria(true);
  }
  async function handleCriarPrimariaConfirm(payload) {
    try {
      const p = {
        causador: UP(payload.causador || ""),
        causa_primaria: UP(payload.causa_primaria || ""),
        causa_secundaria: UP(payload.causa_secundaria || ""),
        quando_utilizado: String(payload.quando_utilizado || "").trim(),
        ativo: Number(payload.ativo) ? 1 : 0,
      };
      if (!p.causador || !p.causa_primaria || !p.causa_secundaria || !p.quando_utilizado) {
        return alert("Preencha: Causador, Causa Primária, Causa Secundária e Quando Utilizado.");
      }
      const { data } = await api.post("/desvios/cadastrar", p);
      const r = data?.data;
      setArvore(prev => {
        const next = structuredClone(prev);
        next[r.causador] ??= {};
        next[r.causador][r.causa_primaria] ??= [];
        next[r.causador][r.causa_primaria].push(r);
        return next;
      });
      setOpenCriarPrimaria(false);
      setCtxPrimaria(null);
    } catch (e) {
      alert(e?.response?.data?.error || "Erro ao cadastrar (primária)");
    }
  }

  const handleCriarConfirm = async (payload) => {
    try {
      const p = {
        causador: UP(payload.causador || ""),
        causa_primaria: UP(payload.causa_primaria || ""),
        causa_secundaria: UP(payload.causa_secundaria || ""),
        quando_utilizado: String(payload.quando_utilizado || "").trim(),
        ativo: Number(payload.ativo) ? 1 : 0,
      };
      if (!p.causador || !p.causa_primaria || !p.causa_secundaria || !p.quando_utilizado) {
        return alert("Preencha: Causador, Causa Primária, Causa Secundária e Quando Utilizado.");
      }
      const { data } = await api.post("/desvios/cadastrar", p);
      const r = data?.data;
      setArvore(prev => {
        const next = structuredClone(prev);
        next[r.causador] ??= {};
        next[r.causador][r.causa_primaria] ??= [];
        next[r.causador][r.causa_primaria].push(r);
        return next;
      });
      setOpenCriar(false);
    } catch (e) {
      alert(e?.response?.data?.error || "Erro ao cadastrar");
    }
  };

  const handleEditarConfirm = async (payload) => {
    try {
      const id = payload?.id;
      if (!id) return;
      const body = {
        causador: UP(payload.causador ?? payload.causador_atual ?? ""),
        causa_primaria: UP(payload.causa_primaria ?? payload.causa_primaria_atual ?? ""),
        causa_secundaria: UP(payload.causa_secundaria ?? ""),
        quando_utilizado: String(payload.quando_utilizado ?? "").trim(),
        ativo: Number(payload.ativo ?? 1) ? 1 : 0,
      };
      const { data } = await api.put(`/desvios/editar/${id}`, body);
      const r = data?.data;

      setArvore(prev => {
        const next = structuredClone(prev);
        outer: for (const c of Object.keys(next)) {
          for (const p of Object.keys(next[c])) {
            const i = next[c][p].findIndex(x => x.id === id);
            if (i >= 0) {
              next[c][p].splice(i,1);
              if (next[c][p].length === 0) delete next[c][p];
              if (Object.keys(next[c]||{}).length === 0) delete next[c];
              break outer;
            }
          }
        }
        next[r.causador] ??= {};
        next[r.causador][r.causa_primaria] ??= [];
        next[r.causador][r.causa_primaria].push(r);
        return next;
      });

      setEditarRow(null);
    } catch (e) {
      alert(e?.response?.data?.error || "Erro ao editar");
    }
  };

  function goHome() {
    if (onBack) onBack();
    else if (window.history.length > 1) window.history.back();
    else window.location.href = "/";
  }

  const causadoresKeys = useMemo(
    () => Object.keys(arvore).sort((a,b)=>a.localeCompare(b,"pt-BR",{sensitivity:"base"})),
    [arvore]
  );
  const visiveis = filtroCausador ? [filtroCausador] : causadoresKeys;

  return (
    <div className="dvz-shell">
      {/* TOPBAR */}
      <div className="dvz-topbar">
        <button className="dvz-btn-hero left" type="button" onClick={goHome}>Voltar para o início</button>
        <h1 className="dvz-title">Catálago de Desvios — Fechamento</h1>
        <button className="dvz-btn-hero right" type="button" onClick={()=>setOpenCriar(true)}>Cadastrar</button>
      </div>

      {/* MÉTRICAS */}
      <div className="dvz-cards">
        <div className="dvz-cards-row dvz-cards--all">
          {/* Causadores */}
          <div className="dvz-card-stack">
            <div className="dvz-card dvz-card--wide">
              <div className="dvz-card__label">CAUSADORES</div>
              <div className="dvz-card__value">{stats.totalCausadores}</div>
            </div>
            <div className="dvz-card dvz-card--ok">
              <div className="dvz-card__label">ATIVOS</div>
              <div className="dvz-card__value">{stats.causadoresAtivos}</div>
            </div>
            <div className="dvz-card dvz-card--alert">
              <div className="dvz-card__label">INATIVOS</div>
              <div className="dvz-card__value">{stats.causadoresInativos}</div>
            </div>
          </div>

          {/* Primárias */}
          <div className="dvz-card-stack">
            <div className="dvz-card dvz-card--wide">
              <div className="dvz-card__label">CAUSAS PRIMÁRIAS</div>
              <div className="dvz-card__value">{stats.primarias}</div>
            </div>
            <div className="dvz-card dvz-card--ok">
              <div className="dvz-card__label">ATIVAS</div>
              <div className="dvz-card__value">{stats.primariasAtivas}</div>
            </div>
            <div className="dvz-card dvz-card--alert">
              <div className="dvz-card__label">INATIVAS</div>
              <div className="dvz-card__value">{stats.primariasInativas}</div>
            </div>
          </div>

          {/* Secundárias */}
          <div className="dvz-card-stack">
            <div className="dvz-card dvz-card--wide">
              <div className="dvz-card__label">CAUSAS SECUNDÁRIAS</div>
              <div className="dvz-card__value">{stats.secundarias}</div>
            </div>
            <div className="dvz-card dvz-card--ok">
              <div className="dvz-card__label">ATIVAS</div>
              <div className="dvz-card__value">{stats.secundariasAtivas}</div>
            </div>
            <div className="dvz-card dvz-card--alert">
              <div className="dvz-card__label">INATIVAS</div>
              <div className="dvz-card__value">{stats.secundariasInativas}</div>
            </div>
          </div>

          {/* POR GRUPO */}
          <div className="dvz-chips-panel dvz-chips-panel--inline">
            <div className="dvz-chips-panel__label">POR GRUPO</div>
            <div className="dvz-chip-list">
              {stats.chips.map(([c, q]) => (
                <button
                  key={c}
                  type="button"
                  className={`dvz-chip ${filtroCausador && UP(filtroCausador) === c ? "active" : ""}`}
                  onClick={() => setFiltroCausador(prev => (prev && UP(prev) === c ? null : c))}
                  title={`Filtrar por ${c}`}
                >
                  {c}<span className="dvz-chip__num">{q}</span>
                </button>
              ))}
              {filtroCausador && (
                <button className="dvz-chip dvz-chip--clear" type="button" onClick={() => setFiltroCausador(null)} title="Limpar filtro">
                  Limpar ✕
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* LISTAGEM */}
      <div className="dvz-wrap">
        {loading ? (
          <div className="dvz-empty">Carregando…</div>
        ) : err ? (
          <div className="dvz-empty">{err}</div>
        ) : visiveis.length === 0 ? (
          <div className="dvz-empty">Nenhum desvio encontrado.</div>
        ) : (
          visiveis.map((causador) => {
            const linhas = buildRows(arvore[causador] || {});
            return (
              <section className="dvz-group" key={causador}>
                <header className="dvz-group__head">
                  <div className="dvz-head-left">
                    <button
                      type="button"
                      className="dvz-btn dvz-btn-lite"
                      onClick={() => abrirPopupPrimaria(causador)}
                      title="Cadastrar nova causa primária neste causador"
                    >
                      Cadastrar Primária
                    </button>
                  </div>

                  <h2 className="dvz-causador">{UP(causador)}</h2>

                  <div className="dvz-head-actions">
                    <ToggleSwitch
                      on={isCausadorAtivo(causador)}
                      onToggle={() => pedirToggleCausador(causador)}
                      title={isCausadorAtivo(causador) ? "Inativar causador" : "Ativar causador"}
                    />
                    <button className="dvz-icon-btn" title="Excluir causador" onClick={() => pedirExcluirCausador(causador)}>
                      <IconTrash />
                    </button>
                  </div>
                </header>

                <div className="dvz-table-wrap">
                  <table className="dvz-table">
                    <colgroup>
                      <col style={{ width: "22%" }} />
                      <col style={{ width: "30%" }} />
                      <col style={{ width: "32%" }} />
                      <col style={{ width: "16%"  }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>CAUSA PRIMÁRIA</th>
                        <th>CAUSA SECUNDÁRIA</th>
                        <th>QUANDO UTILIZADO</th>
                        <th>CONTROLES</th>
                      </tr>
                    </thead>
                    <tbody>
                      {linhas.length === 0 ? (
                        <tr><td className="dvz-td" colSpan={4}>Nenhuma causa secundária.</td></tr>
                      ) : (
                        linhas.map((row) =>
                          row._sep ? (
                            <tr key={row._key}><td colSpan={4} className="dvz-sep" /></tr>
                          ) : (
                            <tr key={row.id}>
                              {row._showPrimaria && (
                                <td className="dvz-td dvz-td-primaria" rowSpan={row._span}>
                                  {UP(row._primaria)}
                                </td>
                              )}
                              <td className="dvz-td">{UP(row.causa_secundaria)}</td>
                              <td className="dvz-td dvz-td-left">{row.quando_utilizado || "—"}</td>
                              <td className="dvz-td dvz-td-controls">
                                <div className="dvz-actions dvz-actions--cluster">
                                  <ToggleSwitch
                                    on={!!Number(row.ativo)}
                                    onToggle={() => pedirToggleSec(row)}
                                    title={Number(row.ativo) ? "Inativar" : "Ativar"}
                                  />
                                  <span className="dvz-actions-divider" aria-hidden="true" />
                                  <button
                                    className="dvz-icon-btn"
                                    title="Editar"
                                    onClick={() => setEditarRow({ ...row, causador, causa_primaria: row._primaria })}
                                  >
                                    <IconEdit />
                                  </button>
                                  <span className="dvz-actions-divider" aria-hidden="true" />
                                  <button className="dvz-icon-btn" title="Excluir" onClick={() => pedirExcluirSec(row)}>
                                    <IconTrash />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </section>
            );
          })
        )}
      </div>

      {/* POPUPS */}
      {openCriar && <CriarDesvio open onClose={()=>setOpenCriar(false)} onConfirm={handleCriarConfirm} />}

      {openCriarPrimaria && (
        <CriarPrimaria
          open
          contexto={ctxPrimaria}
          onClose={() => { setOpenCriarPrimaria(false); setCtxPrimaria(null); }}
          onConfirm={handleCriarPrimariaConfirm}
        />
      )}

      {editarRow && <EditarDesvio open data={editarRow} onClose={()=>setEditarRow(null)} onConfirm={handleEditarConfirm} />}

      {popup.type?.startsWith("ativar") && (
        <AtivarDesvio
          open
          onClose={closePopup}
          onConfirm={confirmPopup}
          titulo={popup.type === "ativar-causador" ? "Ativar causador" : "Ativar desvio"}
          descricao={
            popup.type === "ativar-causador"
              ? `Ativar TODAS as causas do causador "${UP(popup.payload?.causador)}"?`
              : `Deseja ativar "${popup.payload?.rotulo || "este desvio"}"?`
          }
        />
      )}
      {popup.type?.startsWith("inativar") && (
        <InativarDesvio
          open
          onClose={closePopup}
          onConfirm={confirmPopup}
          titulo={popup.type === "inativar-causador" ? "Inativar causador" : "Inativar desvio"}
          descricao={
            popup.type === "inativar-causador"
              ? `Inativar TODOS os desvios do causador "${UP(popup.payload?.causador)}"?`
              : `Deseja inativar "${popup.payload?.rotulo || "este desvio"}"?`
          }
        />
      )}
      {popup.type?.startsWith("excluir") && (
        <ExcluirDesvio
          open
          onClose={closePopup}
          onConfirm={confirmPopup}
          titulo={popup.type === "excluir-causador" ? "Excluir causador" : "Excluir desvio"}
          descricao={
            popup.type === "excluir-causador"
              ? `Excluir o causador "${UP(popup.payload?.causador)}" e TODAS as suas causas?`
              : `Tem certeza que deseja excluir "${popup.payload?.rotulo || "este desvio"}"?`
          }
        />
      )}
    </div>
  );
}
